import * as Immutable from "immutable";
import UserNotification from "util/UserNotification";
import { AuthenticationActions } from "stores/authentication/AuthenticationStore";
import { toBackendJSON } from "authentication/components/saml/config/helpers/samlConfigConverter";
import { GroupSyncActions } from "authentication/stores/directoryServices/GroupSyncStore";
import { AUTH_SERVICE_TYPE } from "authentication/components/saml/constants";
const notifyOnSuccess = () => UserNotification.success("Authentication service was updated successfully.", "Success");
const notifyOnError = (error) => UserNotification.error(`Updating authentication service failed with status: ${error}`, "Error");
const samlAuthBackendSubmit = async (formValues) => {
  try {
    const { id, teamSyncEnabled, teamSyncIsCurrentlyEnabled, teamSyncGroupAttributeName, teamSyncAllowedGroups } = formValues;
    const payload = toBackendJSON(formValues);
    const result = await (id ? AuthenticationActions.update(id, payload) : AuthenticationActions.create(payload));
    if (result.backend) {
      const {
        backend: { id: backendId }
      } = result;
      const teamSyncPayload = {
        auth_service_backend_id: backendId,
        selection_type: "all",
        selection: Immutable.Set().toJS(),
        config: {
          type: AUTH_SERVICE_TYPE,
          group_attribute_name: teamSyncGroupAttributeName,
          allowed_groups: (teamSyncAllowedGroups || "").split(",").map((value) => value.trim()).filter((value) => value.length > 0)
        }
      };
      if (teamSyncEnabled) {
        if (teamSyncIsCurrentlyEnabled) {
          await GroupSyncActions.update(backendId, teamSyncPayload);
        } else {
          await GroupSyncActions.create(backendId, teamSyncPayload);
        }
      } else if (teamSyncIsCurrentlyEnabled) {
        await GroupSyncActions.delete(backendId);
      }
    }
    notifyOnSuccess();
    return result;
  } catch (error) {
    notifyOnError(error);
    throw error;
  }
};
export default samlAuthBackendSubmit;
